/**
 * Separates YAML frontmatter from markdown body.
 * @param {string} content - The raw markdown content.
 * @returns {Object} { frontmatter: Object, body: string }
 */
export const splitSkillMarkdown = (content) => {
    const text = content || '';
    // Match frontmatter with or without leading/trailing newlines
    const regex = /^---\s*\r?\n([\s\S]*?)\r?\n---\s*\r?\n?([\s\S]*)$/;
    const match = text.trimStart().match(regex);
    
    if (!match) {
        return { frontmatter: {}, body: text };
    }

    const yaml = match[1];
    const body = match[2];
    const frontmatter = {};
    
    yaml.split('\n').forEach(line => {
        const colonIndex = line.indexOf(':');
        if (colonIndex !== -1) {
            const key = line.slice(0, colonIndex).trim();
            let val = line.slice(colonIndex + 1).trim();
            
            // Basic unquoting
            if ((val.startsWith('"') && val.endsWith('"')) || (val.startsWith("'") && val.endsWith("'"))) {
                val = val.slice(1, -1);
            }
            
            if (key) {
                frontmatter[key] = val;
            }
        }
    });

    return { frontmatter, body };
};

/**
 * Combines frontmatter and body into a single markdown string.
 */
export const stringifySkillMarkdown = (frontmatter, body) => {
    const lines = ['---'];
    const n = frontmatter?.name;
    if (n !== undefined && n !== null && String(n).trim() !== '') {
        lines.push(`name: ${n}`);
    }
    const d = frontmatter?.description;
    if (d !== undefined && d !== null && String(d).trim() !== '') {
        lines.push(`description: ${d}`);
    }
    const m = frontmatter?.model;
    if (m !== undefined && m !== null && String(m).trim() !== '') {
        lines.push(`model: ${m}`);
    }
    lines.push('---');
    lines.push('');
    return lines.join('\n') + (body || '').trimStart();
};
